export const isServer = () => import.meta.server;
